module.exports = __webpack_public_path__ + "static/media/flag-not-check.a0ce5020.svg";